export enum LocalStorageKeys {
  SESSIONS_WITH_SELECTED_TOOL = 'sessionsWithSelectedTool',
}

export enum WebProxyToolkitView {
  BROWSER = 'BROWSER',
  NETWORK = 'NETWORK',
  SAVED_PAYLOADS = 'SAVED_PAYLOADS',
}
